// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"ccdcfe88","865":"ea22380d"}[chunkId] + ".chunk.js";
};